/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseFileUploadUrlResponseData } from './genericApiResponseFileUploadUrlResponseData';
import type { GenericApiResponseFileUploadUrlResponseMessage } from './genericApiResponseFileUploadUrlResponseMessage';
import type { GenericApiResponseFileUploadUrlResponsePagination } from './genericApiResponseFileUploadUrlResponsePagination';
import type { GenericApiResponseFileUploadUrlResponseError } from './genericApiResponseFileUploadUrlResponseError';

export interface GenericApiResponseFileUploadUrlResponse {
  data?: GenericApiResponseFileUploadUrlResponseData;
  message?: GenericApiResponseFileUploadUrlResponseMessage;
  pagination?: GenericApiResponseFileUploadUrlResponsePagination;
  error?: GenericApiResponseFileUploadUrlResponseError;
  statusCode?: number;
}
